import { useFeatureFlagObserver } from '@hooks/useFeatureFlagObserver';
import { FeatureFlagKeys } from '@lib/experiment';

/**
 * Whether this workspace gets the inline Get started page, in place of the quick start page and
 * the checklist drawer. Flagsmith buckets by workspace (see `experiment.identify`), so everyone in
 * a workspace gets the same answer.
 */
export const useIsInlineGetStartedEnabled = () =>
  useFeatureFlagObserver(FeatureFlagKeys.enableInlineGetStarted);
